import { Subject } from 'rxjs';
import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { SliceDirection } from '../share/slice';
import { fetchCommonValue } from '../share/utils';
import { ImageState } from '../share/model';

@Component({
  selector: 'app-direction',
  templateUrl: './direction.component.html',
  styleUrls: ['./direction.component.css'],
})
export class DirectionComponent implements OnInit, OnDestroy {
  public maxFrame = '100';
  public choseFrame = '1';
  public choseFrame$ = new Subject<string>();
  @Input()
  direction: SliceDirection | undefined = 'z';
  @Output()
  directionChange = new EventEmitter<SliceDirection>();
  @Input()
  sliceIndex = 1;
  @Output()
  sliceIndexChange = new EventEmitter<number>();
  @Input()
  set related(images: ImageState[]) {
    this.setInputToDefault(images);
  }
  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {}
  private setInputToDefault(images: ImageState[]) {
    if (images.length === 0) {
      return;
    }
    this.changeDirection(
      fetchCommonValue(images, (s: ImageState) => s.slicer.direction),
    );
    this.changeSliceIndex(
      fetchCommonValue(images, (s: ImageState) => s.slicer.index),
    );
    this.setDefaultFrame(
      fetchCommonValue(images, (s: ImageState) => s.slicer.max),
      fetchCommonValue(images, (s: ImageState) => s.slicer.index),
    );
  }
  changeDirection(d: SliceDirection | undefined) {
    if (d === this.direction) {
      return;
    }
    this.direction = d;
    if (d !== undefined) {
      this.directionChange.emit(d);
    }
  }
  public parse(source: string ): number | undefined {
    source === undefined ? '0' : source;
    return parseInt(source, 10);
  }
  changeSliceIndex(slice: number) {
    if (slice === this.sliceIndex) {
      return;
    }
    this.sliceIndex = slice;
    if (slice !== undefined) {
      this.sliceIndexChange.emit(slice);
    }
  }
  setDefaultFrame(max: number, chose: number) {
    this.maxFrame = max.toString();
    this.choseFrame = chose.toString();
  }
}
